import { styled, Box, IconButton, TextField } from '@mui/material';
import color from 'src/theme/color';

export const ServicesCard = styled(Box)({
    width: '40%',
    background: color.blackLight,
    borderRadius: '8px',
    padding: '30px 40px 60px 40px',
    position: 'relative',
    color: color.white,
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center'
});

export const IconButtonStyled = styled(IconButton)({
    color: '#FFFFFFCC',
    borderRadius: '50%',
    transition: 'all 0.3s ease',
    '&:hover': {
        color: color.yellow,
        backgroundColor: color.yellowTransparent
    }
});

export const ButtonContentBox = styled(Box)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    width: '30%',
    margin: '0 auto'
});

export const TitleContainer = styled(Box)({
    display: 'flex',
    alignItems: 'center',
    position: 'relative'
});

export const StyledTextField = styled(TextField)({
    '& .MuiInputBase-root': {
        height: '50px'
    }
});

export const MultilineTextField = styled(TextField)({
    '& .MuiInputBase-root': {
        minHeight: '50px',
        height: 'auto'
    }
});

export const FlexContainer = styled(Box)({
    display: 'flex',
    gap: '8px',
    flexWrap: 'wrap',
    position: 'relative'
});

export const SkillChip = styled(Box, {
    shouldForwardProp: (prop) => prop !== 'isHovered'
})<{ isHovered?: boolean }>(({ isHovered }) => ({
    display: 'flex',
    alignItems: 'center',
    padding: '5px 10px',
    borderRadius: '20px',
    backgroundColor: isHovered
        ? color.yellowTransparent1
        : color.greyTransparent,
    color: color.white80,
    '&:hover': {
        backgroundColor: color.yellowTransparent1,
        cursor: 'pointer',
        transition: 'background-color 0.3s'
    }
}));

export const AddButton = styled(Box, {
    shouldForwardProp: (prop) => prop !== 'isHovered'
})<{ isHovered?: boolean }>(({ isHovered }) => ({
    display: 'flex',
    alignItems: 'center',
    padding: '5px 10px',
    borderRadius: '20px',
    backgroundColor: isHovered ? color.yellow : color.yellowTransparent,
    color: isHovered ? color.white : color.yellow,
    marginLeft: 'auto',
    '&:hover': {
        cursor: 'pointer'
    }
}));

export const ConnectChipActive = styled(Box)({
    display: 'flex',
    alignItems: 'center',
    padding: '5px 10px',
    borderRadius: '20px',
    border: `1px solid ${color.yellow60}`,
    backgroundColor: color.greyTransparent,
    color: color.white80,
    position: 'relative'
});

export const TeamMemberChip = styled(Box)({
    display: 'flex',
    alignItems: 'center',
    padding: '5px 10px',
    borderRadius: '20px',
    color: color.white80,
    backgroundColor: color.greyTransparent
});

export const TeamMemberRole = styled('span')({
    marginLeft: '8px',
    color: color.white50
});

export const IconStyle = {
    marginLeft: '8px',
    width: '17px',
    height: '17px'
};

export const AddIconStyle = {
    marginLeft: '8px',
    width: '18px',
    height: '18px'
};

export const CheckIconStyle = {
    position: 'absolute',
    top: '-4px',
    right: '-4px',
    width: '12px',
    height: '12px',
    fill: color.yellow
};

export const CloseIconStyle = (isHovered: boolean) => ({
    marginLeft: '4px',
    marginTop: '2px',
    fill: isHovered ? color.yellowTransparent2 : color.greyIcon,
    cursor: 'pointer'
});

export const MDEditorContainer = styled(Box)({
    marginBottom: '16px',
    width: '100%',

    /* Remove MDEditor background */
    '& .w-md-editor': {
        backgroundColor: 'transparent !important',
        color: `${color.white} !important`
    },

    '& .w-md-editor-toolbar': {
        backgroundColor: 'transparent !important',
        borderBottom: `1px solid ${color.white10} !important`
    },

    '& .w-md-editor-content': {
        backgroundColor: 'transparent !important'
    },

    '& .w-md-editor-text-pre, & .w-md-editor-text-input, & .w-md-editor-text': {
        backgroundColor: 'transparent !important',
        color: `${color.white} !important`
    },

    '& .w-md-editor-toolbar button': {
        color: `${color.white} !important`
    },

    '& .w-md-editor-toolbar button:hover': {
        backgroundColor: `${color.white10} !important`
    }
});

export const AttachmentsContainer = styled(Box)({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: '8px'
});

export const HiddenFileInput = styled('input')({
    display: 'none'
});

export const AttachmentIconButton = styled('button')({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '40px',
    height: '40px',
    borderRadius: '8px',
    backgroundColor: color.white10,
    border: 'none',
    cursor: 'pointer',
    transition: 'background-color 0.2s ease',

    '&:hover': {
        backgroundColor: 'rgba(255, 255, 255, 0.2)'
    },

    '& svg': {
        width: '24px',
        height: '24px',
        color: color.lightningYellow
    }
});
